import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import validator from 'validator';

export const PortValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    // isPort returns true for 0, but 0 is not a valid port
    if (validator.isPort(value) && value !== '0') {
      return { valid: true };
    }

    return {
      valid: false,
      error: errorMessage,
    };
  };
};
